import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./page/Login";
import Sidebar from "./components/Sidebar";
import DashboardPage from "./page/DashboardPage";
import ProjectPage from "./page/ProjectPage";
import UserPage from "./page/UserPage";
import Service from "./page/Service";
import { ToastContainer } from "react-toastify";
import Staff from "./page/Staff";
import Profile from "./page/profile";
import ProtectedRoute from "./components/ProtectedRoute";
import TicketPage from "./page/ticketPage";
import Store from "./page/Store";
import TicketDetail from "./page/TicketDetail";
import TicketForm from "./page/TicketForm";
import "react-toastify/dist/ReactToastify.css";
import MonitorPage from "./page/MonitorPage";
import CounterPage from "./page/CounterPage";


// --- SỬA TẠI ĐÂY ---
import LineDashboard from "./page/linePage"; 
// -------------------

const Layout = () => {
  const location = useLocation();

  const pathsWithoutSidebar = [
    "/login",
    "/projects/:slug",    
    "/services/:serviceId",
    "/ticket/:ticketId",
    "/monitor",
    "/counter"
  ];

  const hideSidebar = pathsWithoutSidebar.some((path) => {
    if (!path.includes(":")) {
      return location.pathname === path;
    } else {
      const basePath = path.split("/:")[0];
      return location.pathname.startsWith(basePath) && location.pathname !== "/tickets";
    }
  });

  return (
    <div className="flex">
      {!hideSidebar && <Sidebar />}
      <div className={`flex-1 ${hideSidebar ? "" : "bg-gray-50"}`}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          
          <Route path="/projects/:slug" element={<Store />} />
          <Route path="/services/:serviceId" element={<TicketForm />} />
          <Route path="/ticket/:ticketId" element={<TicketDetail />} />

          <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
              <Route path="/user" element={<UserPage />} />
              <Route path="/project" element={<ProjectPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['superadmin', 'admin']} />}>
              <Route path="/dashboard" element={<DashboardPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
              <Route path="/staff" element={<Staff />} />
              <Route path="/service" element={<Service />} />
              <Route path="/tickets" element={<TicketPage />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/line" element={<LineDashboard />} /> 

          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin', 'staff']} />}>
              <Route path="/monitor" element={<MonitorPage />} />
              <Route path="/counter" element={<CounterPage />} />

          </Route>

        </Routes>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Layout />
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </Router>
  );
};

export default App;